import React, { useEffect, useMemo } from 'react';

import { useLazyReadCommunitiesQuery } from 'features/admin/features/communities/service/adminCommunitiesApi';

import { useFilters } from '../../../../shops/features/products/hooks/useFilters';
import { CommonTableProps } from '../../../../crm/interfaces/common.interface';
import { FETCH_DELAY } from '../../../../crm/utils/common';
import {
    CommunitiesFiltersProps,
    CommunitiesProps,
} from '../service/communities.interface';
import { getColumns } from '../utils/getColumns';
import { Download, Type } from '../../../components/Download';
import UniversalTable from '../../../components/UniversalTable';

export const CommunitiesContainer = () => {
    const { updateFilters, filters, get, source, loading } = useFilters<
        CommunitiesFiltersProps,
        CommunitiesProps
    >(useLazyReadCommunitiesQuery, null);

    const tableProps = useMemo<
        CommonTableProps<CommunitiesProps, CommunitiesFiltersProps>
    >(
        () => ({
            loading,
            source,
            filters,
            updateFilters,
            getColumns,
            entityName: 'Сообществ',
            rowKey: item => item.id,
        }),
        [loading, source, filters, updateFilters]
    );

    useEffect(() => {
        const timeout = setTimeout(() => {
            get({ filters: filters }, true);
        }, FETCH_DELAY);
        return () => clearTimeout(timeout);
    }, [filters, get]);

    return (
        <>
            <Download type={Type.communities} />
            <UniversalTable {...tableProps} />
        </>
    );
};
